<template>
 <footer class="footer footer-big" data-background-color="black">
                <div class="container">
                    <div class="content">
                        <div class="row">
                            <div class="col-md-3">
                                <a href="#pablo">
                                    <img src="/img/main/5.jpg" width="100" alt="AightBet Now">
                                </a>
                                <br><br>
                                <p>Aight Bet is your home to premium reviews of betting agencies and well researched free predictions, created for a community of people like you!</p>
                            </div>
                            <div class="col-md-3">
                                <h5>About Us</h5>
                                <ul class="links-vertical">
                                    <li>
                                        <a href="/#/blog" class="text-muted">
                                            Blog
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/#/membersRegisteration" class="text-muted">
                                            Members Registration
                                        </a>
                                    </li>
                                    <!-- <li>
                                        <a href="/#/" class="text-muted">
                                            Contact Us
                                        </a>
                                    </li> -->
                                    <li>
                                        <a href="/#/memberslogin" class="text-muted">
                                            Members Login
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-3">
                                <h5>Betting Tips</h5>
                                <ul class="links-vertical">
                                    <li>
                                        <a href="/#/australiaReview" class="text-muted">
                                            Australia Betting Tips
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/#/usaReview" class="text-muted">
                                            USA Betting Tips
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/#/prediction" class="text-muted">
                                            Predictions
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/#/evPuntingMain/Sports" class="text-muted">
                                            +EV Punting | Sports
                                        </a>
                                    </li>
                                     <li>
                                        <a href="/#/evPuntingMain/HorseRacing" class="text-muted">
                                            +EV Punting | Horse Racing
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/#/freeCompetions" class="text-muted">
                                            Free Competitions
                                        </a>
                                    </li>
                                    <!-- <li>
                                        <a href="/#/trumpyTips" class="text-muted">
                                            The System's Tips
                                        </a>
                                    </li> -->
                                </ul>
                            </div>
                            <div class="col-md-3">
                                <h5>Follow Us</h5>
                                <ul class="social-buttons">
                                    <li class="soc-li">
                                        <a href="https://www.facebook.com/groups/391226215611418/?ref=share" target="_blank" class="btn btn-icon btn-neutral btn-facebook btn-round">
                                            <i class="fab fa-facebook-square"></i>
                                        </a>
                                    </li>
                                    <li class="soc-li">
                                        <a href="https://instagram.com/aightbetnow?igshid=125jw6yqld5y1" target="_blank" class="btn btn-icon btn-neutral btn-instagram btn-round">
                                            <i class="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li class="soc-li">
                                        <a href="https://t.me/joinchat/JIehTx20apwvTmryseitxg" target="_blank" class="btn btn-icon btn-neutral btn-twitter btn-round">
                                            <i class="fab fa-telegram"></i>
                                        </a>
                                    </li>
                                    <li class="soc-li">
                                        <a href="https://vm.tiktok.com/ZSCUoBqP/" target="_blank" class="btn btn-icon btn-neutral btn-facebook btn-round">
                                            <i class="fab fa-tiktok"></i>
                                        </a>
                                    </li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="copyright">
                        Copyright &copy;
                        {{year}}
                        Aight Bet Now.
                        Developed by <a href="https://tefer.io"> Tefer.io</a>
                    </div>
                </div>
            </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style scoped>
.soc-li{
    margin: 5px !important;
}
</style>
